import React from 'react';
import { Grid3x3 } from 'lucide-react';
import { useAskSwirlStore } from '../../stores/askSwirlStore';

/**
 * Card Selector Button
 * Opens the context selector (like ChatGPT's card button)
 */
export default function CardSelectorButton() {
  const { openSelector, chips } = useAskSwirlStore();
  
  // Count chips from Swirlspace selection
  const swirlspaceCount = chips.filter(c => c.source === 'swirlspace').length;

  return (
    <button
      onClick={openSelector}
      className="flex-shrink-0 w-9 h-9 rounded-lg bg-white/90 backdrop-blur-sm border border-neutral-200/60 flex items-center justify-center text-neutral-600 hover:bg-white hover:text-purple-600 transition-all duration-200 shadow-sm hover:shadow-md relative"
      title="Select from Swirlspace"
    >
      <Grid3x3 size={18} />
      {swirlspaceCount > 0 && (
        <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-purple-600 text-white text-[10px] flex items-center justify-center font-bold">
          {swirlspaceCount > 9 ? '9+' : swirlspaceCount}
        </span>
      )}
    </button>
  );
}

